<template>
        <div class="c-slider__slide" :class="{'is-active' : isActive}" :style="{flexBasis: size + 'px'}">
            <section class="u-mt-10">
                <div class="o-container--tablet">
                    <div class="grid__row">
                        <div class="grid-tablet-5 tablet:u-text-right tablet:u-pr-6">
                            <h3>{{ title }}</h3>
                        </div>
                        <div class="grid-tablet-7">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </section>
        </div>
</template>
<script>
    export default {
        props: ['title', 'styleObject'],
        data(){
            return {
                isActive: false,
                size: null,
            }
        },
    }
</script>